import Application from "../../Application";
import GetAllOrganisationsInteractor from "../../organisations/interactors/GetAllOrganisationsInteractor";
import { IUser } from "../../user/model/User";
import { TSearchQueryRequest } from "../service/SearchService";
import { ICredentialsService } from "../../authentication/service/CredentialsService";
import SearchCriteriaPresenter, {
  ISearchCriteriaPresenter
} from "../presenter/SearchCriteriaPresenter";
import { GenericCodebookTypes } from "../../core/common/Constants";
import GetHarmonizedIndexTreeInteractor from "../../organisations/interactors/GetHarmonizedIndexTreeInteractor";
import GetAllIndexTypeCategoriesInteractor from "../../indexTypes/interactors/GetAllIndexTypeCategoriesInteractor";
import { SEARCH_SORT_FIELDS } from "../common/Constants";
import GetGenericCodebookInteractor from "../../codebooks/interactor/GetGenericCodebookInteractor";

export default class ShowAdvancedSearchCriteriaInteractor {
  private application: Application;
  private output?: ISearchCriteriaPresenter;
  private getAllOrganisations: GetAllOrganisationsInteractor;
  private credentialsService: ICredentialsService;
  private getGenericCodebook: GetGenericCodebookInteractor;
  private getHarmonizedIndexTree: GetHarmonizedIndexTreeInteractor;
  private getAllIndexTypeCategories: GetAllIndexTypeCategoriesInteractor;

  constructor({
    application,
    getAllOrganisations,
    credentialsService,
    getGenericCodebook,
    getHarmonizedIndexTree,
    getAllIndexTypeCategories
  }: any) {
    this.application = application;
    this.getAllOrganisations = getAllOrganisations;
    this.credentialsService = credentialsService;
    this.getGenericCodebook = getGenericCodebook;
    this.getHarmonizedIndexTree = getHarmonizedIndexTree;
    this.getAllIndexTypeCategories = getAllIndexTypeCategories;
  }

  private async getReferenceLists() {
    const indexCategories = await this.getAllIndexTypeCategories.execute();

    return Promise.all([
      indexCategories,
      this.getAllOrganisations.execute(),
      Promise.all(
        indexCategories.map((category) =>
          this.getHarmonizedIndexTree.execute(category.id)
        )
      ),
      this.getCurrentLanguageCode(),
      this.getGenericCodebook.execute(
        GenericCodebookTypes.COURT_CASE_TYPE,
        false
      ),
      this.getGenericCodebook.execute(GenericCodebookTypes.DECISION_TYPE, false)
    ]);
  }

  private async getCurrentLanguageCode() {
    const currentLanguage = await this.credentialsService.getLanguage();
    return String(currentLanguage);
  }

  execute(query: TSearchQueryRequest) {
    const { user }: { user: IUser } = this.application.store.getState();
    this.output = SearchCriteriaPresenter({
      application: this.application,
      initialState: {
        searchQuery: query,
        sortFields: SEARCH_SORT_FIELDS,
        canCreateDocuments: !this.application.isPortal()
      }
    });
    Promise.resolve({})
      .then(() => this.getReferenceLists())
      .then(
        ([
          indexCategories,
          organisations,
          indexTrees,
          currentLanguage,
          courtCaseTypes,
          decisionTypes
        ]) =>
          this.output?.loadReferenceValues(
            indexCategories,
            organisations,
            indexTrees,
            currentLanguage,
            courtCaseTypes,
            decisionTypes
          )
      );
    return this.output;
  }
}
